/** @graphql cc **/
import gql from 'graphql-tag';

import { fg } from '@confluence/feature-gating';
import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';

import {
	SitePermissionType,
	type fetchPresenceConfluenceUsersQuery as UsersQuery$data,
	type fetchPresenceConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceConfluenceUsersQuery';

export const fetchPresenceConfluenceUsers = (accountIds: string[]) => {
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceConfluenceUsersQuery(
					$accountIds: [String]
					$shouldIncludePermissionType: Boolean = true
				) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							profilePicture {
								isDefault
								path(type: RELATIVE)
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							displayName
							permissionType @include(if: $shouldIncludePermissionType)
						}
					}
				}
			`,
			variables: {
				accountIds,
				shouldIncludePermissionType: !fg('confluence_team_presence_guest_query'),
			},
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user) => (user as any)?.accountId)
					.map((user) => ({
						avatar: user?.profilePicture?.path ?? '',
						email: '',
						isGuest: user?.permissionType === SitePermissionType.EXTERNAL,
						name: user?.displayName ?? '',
						userId: (user as any)?.accountId ?? '',
					})) ?? []
			);
		});
};
